(function($){
	MP.menus_tender = function(){
		var btn = document.getElementById('open_tenders_menu'),
			$menu = btn ? $( btn.parentNode.querySelector('ul') ) : null;
		
		if ( ! btn || ! $menu.length ) return;

		$(btn).html(`
			<span class="l-flex f-c">
				<i class="tenders-menu-btn">
					${$.prototype.menuBtn()}
				</i>
				<span class="tenders-menu-btn-text">Tenders Menu</span>
			</spna>
		`);

		$(btn).on( 'click ', function(){
			var effect = $menu.css('display') === 'none' ? 'Down' : 'Up';
			$menu['slide' + effect](200);
		});
	}
})(window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/m-tenders-menu.js